import * as xScroll from "./x-scroll-util";
import "./x-scroll.scss";

export default function XScroll() {
  xScroll.default();
}
